import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-8 right-8 z-50 bg-green-600 hover:bg-green-700 text-white w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 group border-2 border-white/10 hover:border-white/20 cursor-pointer ${
        isVisible ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible translate-y-4'
      }`}
    >
      <i className="fas fa-chevron-up text-xl group-hover:scale-125 transition-transform duration-300"></i>
      <div className="absolute inset-0 bg-gradient-to-r from-green-600/30 to-green-500/30 rounded-full blur opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10 scale-110"></div>
    </button>
  );
}
